/**
 * Normalizes a VIN string by:
 * - Converting to uppercase
 * - Removing spaces and special characters
 * - Validating length (VINs are typically 17 characters)
 *
 * @param input - The VIN string to normalize
 * @returns Normalized VIN string, or empty string if input is null/undefined
 */
export const normalizeVin = (input: string | null | undefined): string => {
	if (!input) {
		return '';
	}

	return input
		.toUpperCase()
		.replace(/[^A-Z0-9]/g, '')
		.slice(0, 17);
};
